import React from "react";

// Renders a heading string where *phrase* is highlighted in brand blue,
// e.g. "ماذا تستلم مع *متجرك*؟". Plain strings render unchanged.
const MarkedText = ({ text }) => {
    if (typeof text !== "string" || !text.includes("*")) return text ?? null;
    return text.split(/(\*[^*]+\*)/g).map((part, i) =>
        part.startsWith("*") && part.endsWith("*") ? (
            <span key={i} className="text-blue-600">
                {part.slice(1, -1)}
            </span>
        ) : (
            <React.Fragment key={i}>{part}</React.Fragment>
        )
    );
};

export default MarkedText;
